/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function cleanUpEditorArtifacts(): void {
	[ ...document.querySelectorAll( '.ck-body-wrapper .ck-balloon-panel_visible' ) ].forEach( element => {
		element.classList.remove( 'ck-balloon-panel_visible' );
	} );

	document.querySelector( '.ck-body-wrapper .ck-dialog-overlay' )?.remove();
	document.querySelector( '.ck.ckbox-wrapper' )?.remove();

	const uploadCareElements = [
		...document.querySelectorAll( 'uc-config' ),
		...document.querySelectorAll( 'uc-upload-ctx-provider' )
	];

	uploadCareElements.forEach( element => {
		element.remove();
	} );
}
